import * as React from 'react'
import { styled, emphasize } from '@design/pt-ui'

import { MoreHoriz as MoreHorizIcon } from '@mui/icons-material'

const StyledMoreHorizIcon = styled(MoreHorizIcon)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: 2,
  color: theme.palette.grey[700],
  cursor: 'pointer',
  height: 16,
  width: 24,
  marginLeft: theme.spacing(0.5),
  marginRight: theme.spacing(0.5),
  '&:hover, &:focus': {
    backgroundColor: theme.palette.grey[200],
  },
  '&:active': {
    backgroundColor: emphasize(theme.palette.grey[200], 0.12),
    boxShadow: theme.shadows[0],
  },
}))

interface CollapsedItemProps {
  onClick: () => void
}

function CollapsedItem(props: CollapsedItemProps) {
  return <StyledMoreHorizIcon onClick={props.onClick} />
}

export default CollapsedItem
